import { render } from "./shortInfoBlock.vue?vue&type=template&id=77fc5da9"
import script from "./shortInfoBlock.vue?vue&type=script&lang=js"
export * from "./shortInfoBlock.vue?vue&type=script&lang=js"

import "./shortInfoBlock.vue?vue&type=style&index=0&id=77fc5da9&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__